import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { CodePreview, TabPanel, Tabs } from '../ui';
export const GeneratedScript = ({ scripts }) => {
    const tabs = useMemo(() => scripts.map((script) => ({ label: script.label })), [scripts]);
    return (_jsx(Tabs, { variant: 'enclosed', tabs: tabs, children: scripts.map((script) => (_jsx(TabPanel, { children: _jsx(CodePreview, { code: script.script, codeBlockClassName: 'border border-gray-300 -mt-px' }) }, `tab-panel-${script.label}`))) }));
};
